<div class="shop-supplier-dropdown">
  <div class="shop-supplier-inner">
    <!-- Start location -->
    <div class="filter-pill">
      <app-content-overlay [dropshadow]="true" [showArrow]="true" [showArrow]="true"
        [closeAfterAction]="closeAfterAction" right="-5%">
        <ng-template appTemplate="item">
          <div class="filter-pill-inner-wrapper" [ngClass]="{ active: filterApplied.location }"
            [ngStyle]="{'color': filterApplied.location ? shopColor : ''}">
            <!-- Icon -->
            <div class="icon"><i class="fal fa-store-alt"></i></div>

            <!-- Title -->
            <div class="filter-text w-100px text-overflow-ellipsis">
              <span *ngIf="filter?.location?.selected?.length === 0">Location</span>
              <span *ngIf="filter?.location?.selected?.length === 1">{{ (filter?.location?.selected)[0]?.name }}</span>
              <span *ngIf="filter?.location?.selected?.length > 1">{{ filterTitle?.location?.multiple }}</span>
            </div>

            <!-- Clear -->
            <div class="filter-cross">
              <i class="fal fa-chevron-down" *ngIf="!filterApplied?.location"></i>
              <i class="fal fa-times" *ngIf="filterApplied?.location" (click)="clearFilter('location')"></i>
            </div>
          </div>
        </ng-template>

        <ng-template appTemplate="overlay">
          <div class="filter-overlay w-180 text-overflow-ellipsis">
            <app-multiple-filter scrollHeight="265px" nameField="name" [data]="companyLocations" [isSelectAll]="true" [isTextCompany]="true"
              (appChangeFilter)="changeTagFilter('location', $event, true)"> </app-multiple-filter>
          </div>
        </ng-template>
      </app-content-overlay>
    </div>
    <!-- End location -->
  </div>
</div>
